import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthActions } from '@auth/store';
import { ConfigurableMessageActions } from '../actions/configurable-message.actions';
import { ConfigurableMessageService } from '../services/configurable-message.service';
import { ConfigurableMessage } from '@shared/models/referentiel/configurable-message';

@Injectable()
export class ConfigurableMessageEffects {

    initConfigurableMessage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.userProfileLoaded),
            map(() => ConfigurableMessageActions.getConfigurableMessage())
        )
    );

    loadConfigurableMessages$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConfigurableMessageActions.getConfigurableMessage),
            switchMap(() =>
                this.configurableMessageService.getAllActifConfigurableMessages().pipe(
                    map((configurableMessages: ConfigurableMessage[]) => ConfigurableMessageActions.getConfigurableMessageSuccess({ configurableMessages: configurableMessages })),
                    catchError((error) => of(ConfigurableMessageActions.getConfigurableMessageFailure({ errorMessage: error })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private configurableMessageService: ConfigurableMessageService) { }
}
